{
  "slug": "how-is-iq-measured",
  "title": "How is IQ measured?",
  "description": "Understand standardized IQ testing, age-based norms, subtests, percentiles, and why every result has a margin of error.",
  "summary": "IQ is measured with standardized cognitive tasks. Raw performance is compared with age-based norms and converted into a score, commonly centered on 100.",
  "sections": [
    {
      "heading": "From tasks to a standardized score",
      "paragraphs": [
        "An assessment contains multiple subtests. A person may identify patterns, manipulate information in memory, solve verbal problems, or work accurately under time limits. Raw totals have little meaning alone, so publishers compare them with a large reference sample.",
        "Performance is compared with people in the same age band. Scaled subtest scores may then be combined into broader index scores and an overall estimate."
      ]
    },
    {
      "heading": "Norms, percentiles, and spread",
      "paragraphs": [
        "Many current tests use a mean of 100 and a standard deviation of 15. A percentile expresses position: 100 is near the 50th percentile, while 120 is around the 91st percentile under a normal distribution.",
        "Different instruments use different tasks and norms, so two valid tests do not always produce identical scores."
      ]
    },
    {
      "heading": "Why interpretation matters",
      "paragraphs": [
        "Every score includes measurement uncertainty and should usually be reported with a confidence interval. A trained examiner also considers subtest patterns, language, cultural background, testing conditions, and the purpose of the assessment.",
        "Good measurement depends on standard instructions, suitable norms, test security, reliability, and validity. A number without this context can mislead."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Why are some IQ tasks timed?",
      "answer": "Some subtests measure processing efficiency, but many reasoning tasks are untimed or have generous limits. Timing is only one part of an assessment."
    },
    {
      "question": "Can different IQ tests give different results?",
      "answer": "Yes. Content, norms, measurement error, health, and testing conditions can cause reasonable differences."
    }
  ],
  "related": [
    "what-is-iq",
    "what-is-the-average-iq",
    "iq-score-ranges-explained",
    "how-iq-tests-are-standardized-and-normed"
  ]
}
